<template>
  <v-dialog v-model="dialog" width="800" :persistent="true">
    <template v-slot:activator="{ on }">
      <permission-tooltip
          :permission="hasPermission('patient_measurements_create')"
          :tooltip="{right: true, bottom: false, attach: false}"
      >
        <v-btn color="primary" class="ml-0 mr-0" @click="open" :disabled="!hasPermission('patient_measurements_create')">
          {{ 'app.measurements.modal.add' | trans }}
        </v-btn>
      </permission-tooltip>
    </template>
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>{{ modalTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark small @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-md no-padding>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout row wrap>
              <v-flex xs6>
                <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="date"
                        @blur="currentMeasurement.created_at = parseDate(date)"
                        :label="'app.measurements.date' | trans"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        :rules="rules.created_at"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="currentMeasurement.created_at" @input="menu = false"
                                 locale="pl-pl" first-day-of-week="1"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                    :label="'app.measurements.weight' | trans"
                    clearable
                    v-model="currentMeasurement.weight"
                    :rules="rules.weight"
                    full
                    type="number"
                    step="0.01"
                    min="0"
                    @change="weightChange()"
                    @click:clear="weightChange()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <h4>{{ 'app.measurements.circuits' | trans }}</h4>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                    :label="'app.measurements.neck' | trans"
                    clearable
                    v-model="currentMeasurement.neck"
                    :rules="rules.neck"
                    full
                    type="number"
                    step="0.5"
                    min="0"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                    :label="'app.measurements.arm' | trans"
                    clearable
                    v-model="currentMeasurement.arm"
                    :rules="rules.arm"
                    full
                    type="number"
                    step="0.5"
                    min="0"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                    :label="'app.measurements.chest' | trans"
                    clearable
                    v-model="currentMeasurement.chest"
                    :rules="rules.chest"
                    full
                    type="number"
                    step="0.5"
                    min="0"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                    :label="'app.measurements.waist' | trans"
                    clearable
                    v-model="currentMeasurement.waist"
                    :rules="rules.waist"
                    full
                    type="number"
                    step="0.5"
                    min="0"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                    :label="'app.measurements.stomach' | trans"
                    clearable
                    v-model="currentMeasurement.stomach"
                    :rules="rules.stomach"
                    full
                    type="number"
                    step="0.5"
                    min="0"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                    :label="'app.measurements.hips' | trans"
                    clearable
                    v-model="currentMeasurement.hips"
                    :rules="rules.hips"
                    full
                    type="number"
                    step="0.5"
                    min="0"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                    :label="'app.measurements.thigh' | trans"
                    clearable
                    v-model="currentMeasurement.thigh"
                    :rules="rules.thigh"
                    full
                    type="number"
                    step="0.5"
                    min="0"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                    :label="'app.measurements.calf' | trans"
                    clearable
                    v-model="currentMeasurement.calf"
                    :rules="rules.calf"
                    full
                    type="number"
                    step="0.5"
                    min="0"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <h4>{{ 'app.measurements.body_composition_analysis' | trans }}</h4>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                    :label="'app.measurements.water_percentage' | trans"
                    clearable
                    v-model="currentMeasurement.water_percentage"
                    :rules="rules.water"
                    full
                    type="number"
                    step="0.01"
                    min="0"
                    @change="changeWaterPercentage"
                    @click:clear="changeWaterPercentage"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                    :label="'app.measurements.water_mass' | trans"
                    clearable
                    @change="changeWaterMass"
                    @click:clear="changeWaterMass"
                    v-model="water_mass"
                    :rules="rules.water"
                    full
                    type="number"
                    step="0.01"
                    min="0"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                    :label="'app.measurements.fat_percentage' | trans"
                    clearable
                    v-model="currentMeasurement.fat_percentage"
                    :rules="rules.fat"
                    full
                    type="number"
                    step="0.01"
                    min="0"
                    @change="changeFatPercentage"
                    @click:clear="changeFatPercentage"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                    :label="'app.measurements.fat_mass' | trans"
                    clearable
                    @change="changeFatMass"
                    @click:clear="changeFatMass"
                    v-model="fat_mass"
                    :rules="rules.fat"
                    full
                    type="number"
                    step="0.01"
                    min="0"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                    :label="'app.measurements.muscle_percentage' | trans"
                    clearable
                    v-model="currentMeasurement.muscle_percentage"
                    :rules="rules.muscle"
                    full
                    type="number"
                    step="0.01"
                    min="0"
                    @click:clear="changeMusclePercentage"
                    @change="changeMusclePercentage"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                    :label="'app.measurements.muscle_mass' | trans"
                    clearable
                    v-model="muscle_mass"
                    :rules="rules.muscle"
                    full
                    type="number"
                    step="0.01"
                    min="0"
                    @change="changeMuscleMass"
                    @click:clear="changeMuscleMass"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                    :label="'app.measurements.bones_percentage' | trans"
                    clearable
                    v-model="currentMeasurement.bones_percentage"
                    :rules="rules.bones"
                    full
                    type="number"
                    step="0.01"
                    min="0"
                    @change="changeBonesPercentage"
                    @click:clear="changeBonesPercentage"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                    :label="'app.measurements.bones_mass' | trans"
                    clearable
                    v-model="bones_mass"
                    :rules="rules.bones"
                    full
                    type="number"
                    step="0.01"
                    min="0"
                    @change="changeBonesMass"
                    @click:clear="changeBonesMass"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>

      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="close">
          {{ 'app.close' | trans }}
        </v-btn>
        <v-btn color="primary" @click="save" :disabled="!valid" :loading="loading">
          {{ 'app.save' | trans }}
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import {trans} from "../../app";
import MeasurementService from "../../services/MeasurementService";
import {mapActions, mapGetters} from "vuex";
import moment from 'moment';
import {round} from "../../utils/money";
import {FORMAT_DATE, SYSTEM_DATE} from "../../utils/dateFormatter";

export default {
  data: function () {
    return {
      menu: false,
      dialog: false,
      valid: false,
      loading: false,
      water_mass: null,
      fat_mass: null,
      muscle_mass: null,
      bones_mass: null,
      currentMeasurement: {
        id: null,
        created_at: '',
        weight: null,
        neck: null,
        arm: null,
        chest: null,
        waist: null,
        stomach: null,
        hips: null,
        thigh: null,
        calf: null,
        water_percentage: null,
        fat_percentage: null,
        muscle_percentage: null,
        bones_percentage: null,
      },
      date: '',
      inputs: [
        'weight',
        'neck',
        'arm',
        'chest',
        'waist',
        'stomach',
        'hips',
        'thigh',
        'calf',
        'water',
        'fat',
        'muscle',
        'bones'
      ]
    };
  },
  props: {
    patientId: Number,
  },
  methods: {
    ...mapActions(['fetchMeasurements', 'setInitialEditedMeasurement']),
    open() {
      this.$refs.form.reset();
      this.dialog = true;
      this.currentMeasurement = Object.assign({}, this.editedMeasurement);
      if (!this.currentMeasurement.created_at) {
        this.currentMeasurement.created_at = moment().format(SYSTEM_DATE);
      } else {
        this.currentMeasurement.created_at = moment(this.currentMeasurement.created_at).format(SYSTEM_DATE);
      }
      this.date = this.formatDate(this.currentMeasurement.created_at);
      this.calculateMasses();
    },
    close() {
      this.$refs.form.reset();
      this.dialog = false;
      this.setInitialEditedMeasurement();
    },
    async save() {
      if (this.$refs.form.validate() === false) {
        return;
      }

      this.loading = true;
      const measurementService = new MeasurementService();

      if (this.currentMeasurement.id) {
        await measurementService.updateMeasurement(this.patientId, this.currentMeasurement);
      } else {
        await measurementService.saveMeasurement(this.patientId, this.currentMeasurement);
      }
      await this.fetchMeasurements({patientId: this.patientId});
      this.setInitialEditedMeasurement();
      this.loading = false;
      this.close();
      if (this.currentMeasurement.id) {
        this.$toast.success(trans('app.actions.edited', {name: trans('app.measurement').toLowerCase()}));
      } else {
        this.$toast.success(trans('app.actions.added', {name: trans('app.measurement').toLowerCase()}));
      }
      this.$emit('fetchData');
      this.$root.$emit('measurementStored');
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      return moment(date).format(FORMAT_DATE)
    },
    parseDate(date) {
      if (!date) {
        return '';
      }
      return moment(date, FORMAT_DATE).format(SYSTEM_DATE);
    },
    changeWaterPercentage(waterPercentage) {
      if (this.currentMeasurement.weight && waterPercentage) {
        this.water_mass = round(+this.currentMeasurement.weight * +waterPercentage / 100, 2);
      } else {
        this.muscle_mass = null;
      }
    },
    changeWaterMass(waterMass) {
      if (this.currentMeasurement.weight && waterMass) {
        this.currentMeasurement.water_percentage = round(+waterMass / +this.currentMeasurement.weight * 100, 2);
      } else {
        this.currentMeasurement.water_percentage = null;
      }
    },
    changeFatPercentage(fatPercentage) {
      if (this.currentMeasurement.weight && fatPercentage) {
        this.fat_mass = round(+this.currentMeasurement.weight * +fatPercentage / 100, 2);
      } else {
        this.fat_mass = null;
      }
    },
    changeFatMass(fatMass) {
      if (this.currentMeasurement.weight && fatMass) {
        this.currentMeasurement.fat_percentage = round(+fatMass / +this.currentMeasurement.weight * 100, 2);
      } else {
        this.currentMeasurement.fat_percentage = null;
      }
    },
    changeMusclePercentage(musclePercentage) {
      if (this.currentMeasurement.weight && musclePercentage) {
        this.muscle_mass = round(+this.currentMeasurement.weight * +musclePercentage / 100, 2);
      } else {
        this.muscle_mass = null;
      }
    },
    changeMuscleMass(muscleMass) {
      if (this.currentMeasurement.weight && muscleMass) {
        this.currentMeasurement.muscle_percentage = round(+muscleMass / +this.currentMeasurement.weight * 100, 2);
      } else {
        this.currentMeasurement.muscle_percentage = null;
      }
    },
    changeBonesPercentage(bonesPercentage) {
      if (this.currentMeasurement.weight && bonesPercentage) {
        this.bones_mass = round(+this.currentMeasurement.weight * +bonesPercentage / 100, 2)
      } else {
        this.bones_mass = null;
      }
    },
    changeBonesMass(bonesMass) {
      if (this.currentMeasurement.weight && bonesMass) {
        this.currentMeasurement.bones_percentage = round(+bonesMass / +this.currentMeasurement.weight * 100, 2);
      } else {
        this.currentMeasurement.bones_percentage = null;
      }
    },
    weightChange() {
      this.calculateMasses();
    },
    calculateMasses() {
      if (this.currentMeasurement.weight && this.currentMeasurement.water_percentage) {
        this.water_mass = round(+this.currentMeasurement.weight * +this.currentMeasurement.water_percentage / 100, 2);
      } else {
        this.water_mass = null;
      }
      if (this.currentMeasurement.weight && this.currentMeasurement.fat_percentage) {
        this.fat_mass = round(+this.currentMeasurement.weight * +this.currentMeasurement.fat_percentage / 100, 2);
      } else {
        this.fat_mass = null;
      }
      if (this.currentMeasurement.weight && this.currentMeasurement.muscle_percentage) {
        this.muscle_mass = round(+this.currentMeasurement.weight * +this.currentMeasurement.muscle_percentage / 100, 2);
      } else {
        this.muscle_mass = null;
      }
      if (this.currentMeasurement.weight && this.currentMeasurement.bones_percentage) {
        this.bones_mass = round(+this.currentMeasurement.weight * +this.currentMeasurement.bones_percentage / 100, 2);
      } else {
        this.bones_mass = null;
      }
    }
  },
  computed: {
    rules: function () {
      let rules = {};
      this.inputs.forEach((rule) => {
        if (rule === 'weight') {
          rules[rule] = [
            v => !!v || trans('validation.required', {'attribute': trans('app.measurements.' + rule)}),
            v => v && v >= 0 || trans('validation.min.numeric', {
              attribute: trans('app.measurements.' + rule),
              min: 0,
            }),
          ];
        } else {
          rules[rule] = [
            v => (!!!v || v >= 0) || trans('validation.min.numeric', {
              attribute: trans('app.measurements.' + rule),
              min: 0,
            }),
          ];
        }
      });
      rules['created_at'] = [
        v => !!v || trans('validation.required', {'attribute': trans('app.date')}),
      ]
      return rules;
    },
    modalTitle: function () {
      const key = this.currentMeasurement && this.currentMeasurement.id
          ? 'app.measurements.modal.edit'
          : 'app.measurements.modal.add';

      return trans(key);
    },
    ...mapGetters(['editedMeasurement', 'hasPermission']),
  },
  watch: {
    'currentMeasurement.created_at'(measurementCreatedAt) {
      this.date = measurementCreatedAt ? this.formatDate(measurementCreatedAt) : '';
    },
  }
}
</script>
